export const toggleSidebarMenu = ({isOpen, showAnimation = true} = {}) => {
  const sidebarMenu = document.querySelector("aside#sidebarMenu");
  const rootElement = document.querySelector("#root");
  const sidebarMenuButton = document.querySelector("button#sidebarButton");
  const sidebarBackdrop = document.querySelector("#sidebarBackdrop");

  if (sidebarMenu && showAnimation === false) {
    sidebarMenu.style = "--slideOutDuration: 0s; --fideOutDuration: 0s";
  }

  if (sidebarMenu && showAnimation === true) {
    sidebarMenu.style = "";
  }

  if (isOpen === true) {
    sidebarMenu?.classList.add("show");
    document.body.style.overflow = "hidden";
    rootElement.style.overflow = "hidden";
    sidebarMenu?.setAttribute("aria-hidden", "false");
    sidebarBackdrop?.setAttribute("aria-hidden", "false");
    sidebarMenuButton?.setAttribute("aria-expanded", "true");
    return;
  }

  if (isOpen === false) {
    sidebarMenu?.classList?.remove("show");
    document.body.style.overflow = "";
    rootElement.style.overflow = "";
    sidebarMenu?.setAttribute("aria-hidden", "true");
    sidebarBackdrop?.setAttribute("aria-hidden", "true");
    sidebarMenuButton?.setAttribute("aria-expanded", "false");
    return;
  }

  sidebarMenu.classList.toggle("show");

  const hasBeenShown = sidebarMenu.classList.contains("show");
  if (hasBeenShown) {
    document.body.style.overflow = "hidden";
    rootElement.style.overflow = "hidden";
    sidebarMenu.setAttribute("aria-hidden", "false");
    sidebarBackdrop.setAttribute("aria-hidden", "false");
    sidebarMenuButton.setAttribute("aria-expanded", "true");
  } else {
    document.body.style.overflow = "";
    rootElement.style.overflow = "";
    sidebarMenu.setAttribute("aria-hidden", "true");
    sidebarBackdrop.setAttribute("aria-hidden", "true");
    sidebarMenuButton.setAttribute("aria-expanded", "false");
  }
};
